import React, { useState, useEffect } from 'react';
import { getSavingsReports } from 'parity-network-requests';
import Spin from 'antd/lib/spin';
import { useParams } from 'react-router-dom';
import { config } from '../../../../config';

// ICONS
import downloadIconLight from './assets/download-light.svg';
import downloadIconDark from './assets/download-dark.svg';
import pdfIcon from './assets/pdf-icon.svg';

// IMAGES
import noReportsIcon from '../../../../images/no-savings-report.png';

import './DownloadReport.less';

const { REACT_APP_BUILD_ENV } = config;

export const DownloadReport = (props) => {
  const { theme, buildingName } = props;
  const [reportsObj, setReportsObj] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const { building } = useParams();

  useEffect(() => {
    async function fetchData() {
      const buildingReports = await getSavingsReports(REACT_APP_BUILD_ENV, building);
      setReportsObj(buildingReports);
      setIsLoading(false);
    }
    fetchData();
    window.document.title = `${buildingName} | Download Report`;
  }, [building]);

  return (
    <div className="download-report-wrapper">
      <div className={`download-report download-report-${theme}`}>
        {isLoading ? (
          <div className="download-report--loading">
            <Spin size="large" />
          </div>
        ) : (
          <>
            <div className="download-report-section-title">Download Report</div>
            {reportsObj.reports.lenght !== 1 ? (
              <>
                {reportsObj.reports.map((reportTerm) => {
                  const { name, years } = reportTerm;

                  return (
                    <div className="download-report-section" key={name}>
                      <div className="download-report-section-header">
                        <div className="download-report-section-title-terms">{name}</div>
                      </div>
                      {years.map((year) => {
                        const { name: yearName, reports } = year;
                        return (
                          <div className="download-report-section" key="{name}_{yearName}">
                            <div className="download-report-section-header">
                              <div className="download-report-year-section-title-terms">{yearName}</div>
                            </div>
                            {reports.map((report) => {
                              const { name: reportName, url } = report;

                              return (
                                <div className="download-report-report-item" key={reportName}>
                                  <div className="download-report-report-item--title">
                                    <img src={pdfIcon} alt="pdf-icon" className="download-report-report-item-pdf" />
                                    {reportName}
                                  </div>
                                  <a
                                    className="download-report-report-item--download-desktop"
                                    href={url}
                                    target="_blank"
                                    rel="noreferrer"
                                    download
                                  >
                                    Download
                                    {theme === 'light' ? (
                                      <img
                                        className="download-img-desktop"
                                        src={downloadIconLight}
                                        alt="download-icon"
                                      />
                                    ) : (
                                      <img
                                        className="download-img-desktop"
                                        src={downloadIconDark}
                                        alt="download-icon"
                                      />
                                    )}
                                  </a>
                                  <a
                                    className="download-report-report-item--download-mobile"
                                    href={url}
                                    target="_blank"
                                    rel="noreferrer"
                                    download
                                  >
                                    <img className="download-img-mobile" src={downloadIconLight} alt="download-icon" />
                                  </a>
                                </div>
                              );
                            })}
                          </div>
                        );
                      })}
                    </div>
                  );
                })}
              </>
            ) : (
              <div className="download-report-no-reports">
                <img src={noReportsIcon} alt="no-savings" className="no-reports-icon" />
                <div className="download-report-text-main">Downloadable reports of your savings will appear here</div>
                <div className="download-report-text-secondary">
                  Reports are available at the end of each monthly period
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};
